import ComponentHelper from '../../supers/ComponentHelper';
import React from 'react';
import './input-field.css';

class InputField extends ComponentHelper {
	render() {
		let {
			type,
			onKeyDown,
			value,
			handleChange,
			readOnly,
			autoFocus,
			className,
			label,
			required,
			name,
			placeholder,
			subText,
			disabled,
			textarea
		} = this.props;
		return (
			<div className={`input-field ${className ? className : ''}`}>
				<label htmlFor={name}>
					<div className={`label ${required ? 'label--required' : ''}`}>{label}</div>
					{type === 'textarea' && (
						<textarea
							className="text-box"
							name={name}
							value={value}
							onChange={handleChange}
							placeholder={placeholder}
							readOnly={readOnly ? true : false}
							autoFocus={autoFocus ? true : false}
							onKeyDown={onKeyDown}
							autoComplete="do-not-auto-complete"
							disabled={disabled}
						/>
					)}
					{type !== 'textarea' && (
						<input
							className="text-input"
							name={name}
							type={type}
							value={value}
							onChange={handleChange}
							placeholder={placeholder}
							readOnly={readOnly ? true : false}
							autoFocus={autoFocus ? true : false}
							autoComplete="do-not-auto-complete"
							onKeyDown={onKeyDown}
							disabled={disabled}
						/>
					)}
					{subText && <div className="sub-text">{subText}</div>}
				</label>
			</div>
		);
	}
}

export default InputField;



// WEBPACK FOOTER //
// ./src/components/input-field/InputField.js